module.exports = __webpack_public_path__ + "static/media/ic_chevron_left_white_24px.70761a69.svg";